import * as z from "zod/v4";

export const getGoogleReviewFeedUrl = {
  name: "getGoogleReviewFeedUrl" as const,
  input: z.object({ teamId: z.string() }),

  output: z.object({
    enabled: z.boolean(),
    feedUrl: z.string().nullable(),
    lastGenerated: z.date().nullable(),
    reviewCount: z.number().nullable(),
  }),
};
